module.exports = __webpack_public_path__ + "img/icon-gyro.e7433d48.svg";